import { IPCheckbox } from 'baseComponents';
import { IPStack } from 'baseComponents/Stack/IPStack';
import { ReportRequest2DTO } from 'models/dto/Reports/ReportRequests_2_DTO';
import { useTranslation } from 'react-i18next';
import { IReportRequestOptions } from '../ReportRequest';

const ReportOptions2 = (props: IReportRequestOptions) => {
  const { t } = useTranslation(['translation', 'adminReports']);

  const updateOptions = (showOnlyOpenTasks: boolean) => {
    const reportRequest = (props.reportRequest as ReportRequest2DTO).clone();
    reportRequest.showOnlyOpenTasks = showOnlyOpenTasks;
    props.onUpdate(reportRequest, true);
  };

  //
  // Main render
  //
  return (
    <IPStack>
      <IPStack.Item>
        <IPCheckbox
          label={t('adminReports:Dialogs.Request.Options.Report2.ShowOnlyOpenTasks')}
          defaultChecked={true}
          onChange={(ev, checked) => updateOptions(checked ?? false)}
        />
      </IPStack.Item>
    </IPStack>
  );
};

export default ReportOptions2;
